import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Summer/Shape/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Shape',
  field: 'Geometry',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Shape/1UnderstandAndUseDegrees" */ './1UnderstandAndUseDegrees'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year5/Summer/Shape/2ClassifyAngles" */ './2ClassifyAngles')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year5/Summer/Shape/3EstimateAngles" */ './3EstimateAngles')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Shape/4MeasureAnglesUpTo180" */ './4MeasureAnglesUpTo180'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Shape/5DrawLinesAndAnglesAccurately" */ './5DrawLinesAndAnglesAccurately'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Shape/6CalculateAnglesAroundAPoint" */ './6CalculateAnglesAroundAPoint'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Shape/7CalculateAnglesOnAStraightLine" */ './7CalculateAnglesOnAStraightLine'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Shape/8LengthsAndAnglesInShapes" */ './8LengthsAndAnglesInShapes'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Shape/9RegularAndIrregularPolygons" */ './9RegularAndIrregularPolygons'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(/* webpackChunkName: "Year5/Summer/Shape/10Num3DShapes" */ './10Num3DShapes')
    })
  ]
});
export default Block;
